import React from 'react'


const Skill = () => {


  return (
    <div className='bg-[#0C111B] text-white'>

    <section className="px-4  mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 ">
      <h1 id="skill" className="text-4xl font-bold text-center lg:pt-20">
        Skills
      </h1>
      <div className="p-8 ">
        <div>
          <div className="lg:w-full grid gap-x-20 gap-y-6 lg:grid-cols-2  ">
            <div>
              <h1 className="text-xl font-bold mr-4 mb-1">HTML</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[98%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">CSS</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[95%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-1 mb-1">Tailwind css</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[98%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Bootstrap</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[90%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Javascript</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[80%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-4 mb-1">React</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[93%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Node.JS</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[70%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">MongoDB</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[85%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Material UI</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[50%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Redux</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[46%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div>
            <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Next JS</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[35%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
              </div>
               <div>
    
           <div>
              <h1 className="text-xl font-bold mr-9 mb-1">Remix</h1>
              <div className="w-full  rounded-full bg-gray-700">
                <div className="bg-teal-500 text-xs w-[50%] font-medium text-teal-100 text-center py-3 leading-none rounded-full"></div>
              </div>
            </div> 
          </div>
        </div>
          </div>
          </div>
    </section>
    </div>
  )
}

export default Skill
